export class SelectedCards {
  amount?: string;
  productId?: string;
  displayValue?: string;
  isChecked?: boolean;
  icon?: string;
  serviceCategory?: string;
  isRadioOrCheckBox?: string;
  addOnOption?: any;

  constructor(
    amount: string,
    productId: string,
    displayValue: string,
    isChecked: boolean,
    icon?: string,
    serviceCategory?: string,
    isRadioOrCheckBox?: string,
    addOnOption?: any
  ) {
    this.amount = amount;
    this.productId = productId;
    this.displayValue = displayValue;
    this.isChecked = isChecked;
    this.icon = icon;
    this.serviceCategory = serviceCategory;
    this.isRadioOrCheckBox = isRadioOrCheckBox;
    this.addOnOption = addOnOption;
  }

  set setIconPath(icon: string) {
    this.icon = icon;
  }

  get productAmount() {
    return this.amount;
  }

  get headingDisplayValue() {
    return this.displayValue;
  }

  get productID() {
    return this.productId;
  }

  get isProductChecked() {
    return this.isChecked;
  }

  get iconPath() {
    return this.icon;
  }

  get gtServiceCategory() {
    return this.serviceCategory;
  }
}
